import React, { Fragment, useEffect, useState, useCallback } from 'react'
import _ from 'lodash'
import { connect, useSelector } from 'react-redux'
import { api } from '../../services'
import { useTranslation } from 'react-i18next'
import { Spin, Table, Button, Modal, Tag, Icon, Pagination, Typography, Row, Col, Form, Input, InputNumber, message, Tooltip, Select, Tabs } from 'antd'
import history from '../../history'
import './quest.scss'
import NewHeader from '../../components/NewHeader'
import PublishQuestModal from './components/PublishQuestModal/PublishQuestModal'
// import ARUploads from '../Library/components/ARUploads'
import { OrganizationImageSelect } from '../../components/Form/ImageSelect/ImageSelect'
import {
    FaUserEdit
} from 'react-icons/fa'
const { Title, Text } = Typography
const { Option } = Select
const { TabPane } = Tabs

const renderARMedia = (arAsset, style) => {
    if (!arAsset) return null;
    const arFiles = arAsset.ar_files || [];
    const videoFile = arFiles.find(f => f.media_format === 'VIDEO');
    const audioFile = arFiles.find(f => f.media_format === 'AUDIO');
    const imageFile = arFiles.find(f => f.media_format === 'IMAGE');
    const compressedFile = arFiles.find(f => f.media_format === 'COMPRESSED');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            {videoFile ? (
                <video src={videoFile.link} controls style={{ ...style, maxWidth: '100%' }} />
            ) : imageFile ? (
                <img src={imageFile.link} alt="AR Asset" style={style} />
            ) : (
                <img src={arAsset.link} alt="AR Asset" style={style} />
            )}
            
            {audioFile && (
                <audio src={audioFile.link} controls style={{ width: '100%', marginTop: '10px' }} />
            )}

            {compressedFile && (
                <Tag color="cyan" style={{ marginTop: '10px' }}>
                    <Icon type="file-zip" style={{ marginRight: '4px' }} /> 3D Model
                </Tag>
            )}
        </div>
    );
};

const ListQuest = ({ user, orgList }) => {
    const { t } = useTranslation()
    const { active_organization_id, id: user_id } = user?.info
    const [publishModalVisible, setPublishModalVisible] = useState(false)
    const [selectedHuntForPublish, setSelectedHuntForPublish] = useState(null)
    const [isFetching, setIsFetching] = useState(false)
    const [hunts, setHunts] = useState([])
    const [total, setTotal] = useState(0)
    const [query, setQuery] = useState({
        org_id: String(active_organization_id),
        user_id: String(user_id),
        limit: 100,
        offset: 0,
        parent_treasure_hunt: true
    })

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedHunt, setSelectedHunt] = useState(null)
    const [activeIndex, setActiveIndex] = useState(null)
    const [users, setUsers] = useState([])
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [editFormData, setEditFormData] = useState({ story: '', objective: '', fun_fact: '', open_ended: '', points: 0, points_mc: 0, points_open_ended: 0, index: null, ar_asset_id: null })
    const [editModalTab, setEditModalTab] = useState('1')
    const [isMediaLibraryModalOpen, setIsMediaLibraryModalOpen] = useState(false)
    const [isSavingStop, setIsSavingStop] = useState(false)
    const [editQuestModalVisible, setEditQuestModalVisible] = useState(false)
    const [editQuestFormData, setEditQuestFormData] = useState({ title: '', objectives: '' })
    const [isSavingQuest, setIsSavingQuest] = useState(false)
    const [editorModalVisible, setEditorModalVisible] = useState(false)
    const [selectedHuntForEditors, setSelectedHuntForEditors] = useState(null)
    const [isUpdatingEditors, setIsUpdatingEditors] = useState(false)
    const [arAsset, setArAsset] = useState(null)

    useEffect(() => {
        if (!active_organization_id) return
        fetchOrgUsers()
    }, [active_organization_id])

    useEffect(() => {
        getQuestContent()
    }, [query])

    const ageGroupOptions = [
        { label: 'Preschool (3-5)', value: '3-5' },
        { label: 'Elementary (6-10)', value: '6-10' },
        { label: 'Middle School (11-13)', value: '11-13' },
        { label: 'High School (14-18)', value: '14-18' },
        { label: 'Adults (18+)', value: '18+' }
    ]

    const getQuestContent = async () => {
        setIsFetching(true)
        try {
            const res = await api.quest.getQuestContent(query)
            if (res?.data) {
                const huntsWithKeys = (res.data.hunts || []).map((hunt, index) => ({
                    ...hunt,
                    key: `hunt-${index}-${hunt.id || hunt.hunt_id || Date.now()}`,
                }))
                setHunts(huntsWithKeys)
                const apiCount = Number(res.data.count || 0)
                setTotal(Math.max(apiCount, huntsWithKeys.length))
            }
        } catch (error) {
            console.error('Error fetching quests:', error)
        } finally {
            setIsFetching(false)
        }
    }

    const handleView = (hunt) => {
        setSelectedHunt(hunt)
        setIsModalVisible(true)
    }

    const togglePanel = (index) => {
        setActiveIndex(prev => (prev === index ? null : index))
    }

    const handlePageChange = (page, pageSize) => {
        setQuery(prev => ({
            ...prev,
            limit: pageSize,
            offset: (page - 1) * pageSize
        }))
    }

    const handleCloseMainModal = () => {
        setIsModalVisible(false)
    }

    const handleEditStop = (stop, index) => {
        setEditFormData({
            title: stop.title || '',
            story: stop.story || '',
            objective: stop.objective || '',
            fun_fact: stop.fun_fact || '',
            open_ended: stop.quiz?.open_ended || '',
            points: stop.points || 0,
            points_mc: stop.points_mc || 0,
            points_open_ended: stop.points_open_ended || 0,
            index: index,
            ar_asset_id: stop.ar_asset_id || null
        })
        if (stop.ar_asset) {
            setArAsset(stop.ar_asset)
        } else {
            setArAsset(null)
        }
        setEditModalVisible(true)
    }

    const performUpdate = async () => {
        setIsSavingStop(true)
        try {
            const currentStops = [...(selectedHunt.stops || [])]

            if (editFormData.index !== null) {
                currentStops[editFormData.index] = {
                    ...currentStops[editFormData.index],
                    title: editFormData.title,
                    story: editFormData.story,
                    objective: editFormData.objective,
                    fun_fact: editFormData.fun_fact,
                    points: editFormData.points,
                    points_mc: editFormData.points_mc,
                    points_open_ended: editFormData.points_open_ended,
                    ar_asset_id: editFormData.ar_asset_id,
                    quiz: {
                        ...(currentStops[editFormData.index].quiz || {}),
                        open_ended: editFormData.open_ended
                    },
                }
            }

            const payload = {
                ...selectedHunt,
                stops: currentStops.map((stop, index) => ({
                    ...stop,
                    ar_asset: arAsset,
                    stop_number: stop.number || index + 1
                }))
            }

            const params = { user_id, org_id: active_organization_id }
            const res = await api.quest.updateQuest(selectedHunt.hunt_id || selectedHunt.id, params, payload)

            if (res && res.status === 200) {
                message.success('Quest stop updated successfully')
                const huntPayload = {
                    ...selectedHunt,
                    stops: currentStops.map((stop, index) => ({
                        ...stop,
                        ar_asset: arAsset,
                        stop_number: stop.number || index + 1
                    }))
                }
                setSelectedHunt(huntPayload)
                setEditModalVisible(false)
                getQuestContent()
            } else {
                message.error('Failed to update quest stop')
            }
        } catch (error) {
            console.error('Error updating quest stop:', error)
            message.error('An error occurred while updating quest stop')
        } finally {
            setIsSavingStop(false)
        }
    }
    const handleRegenerateQuiz = async (index) => {
        if (!selectedHunt) return
        setIsFetching(true)
        try {
            const stop = selectedHunt.stops[index]
            const stop_number = stop.number || index + 1
            const params = { user_id, org_id: active_organization_id }
            const res = await api.quest.regenerateQuiz(selectedHunt.hunt_id, stop_number, params)

            if (res && res.status === 200 && res.data?.stop?.quiz) {
                message.success('Quiz regenerated successfully')

                // Update local state for immediate feedback
                setSelectedHunt(prev => {
                    if (!prev) return prev;
                    const newStops = [...(prev.stops || [])];
                    if (newStops[index]) {
                        newStops[index] = {
                            ...newStops[index],
                            quiz: res.data.stop.quiz
                        };
                    }
                    return { ...prev, stops: newStops };
                });

                getQuestContent()
            } else {
                message.error('Failed to regenerate quiz')
            }
        } catch (error) {
            console.error('Error regenerating quiz:', error)
            message.error('An error occurred while regenerating quiz')
        } finally {
            setIsFetching(false)
        }
    }

    const handleSelectedImage = (image) => {
        if (image && image.id) {
            setEditFormData(prev => ({ ...prev, ar_asset_id: image.id }))
            setArAsset(image)
        } else {
            setArAsset(null)
        }
        setIsMediaLibraryModalOpen(false)
    }

    const handleSaveQuest = async () => {
        if (!selectedHunt) return
        setIsSavingQuest(true)
        try {
            const payload = {
                title: editQuestFormData.title,
                objectives: editQuestFormData.objectives,
            }
            const params = { user_id, org_id: active_organization_id }
            const res = await api.quest.updateQuest(selectedHunt.hunt_id || selectedHunt.id, params, payload)
            if (res && res.status === 200) {
                message.success('Quest updated successfully')
                setSelectedHunt({ ...selectedHunt, ...payload })
                setEditQuestModalVisible(false)
                getQuestContent()
            } else {
                message.error('Failed to update quest')
            }
        } catch (error) {
            console.error('Error updating quest:', error)
            message.error('An error occurred while updating quest')
        } finally {
            setIsSavingQuest(false)
        }
    }

    const handleOpenEditorModal = (hunt) => {
        if (!hunt?.can_edit) {
            message.error('You do not have permission for this action.')
            return
        }
        setSelectedHuntForEditors(hunt)
        setEditorModalVisible(true)
    }

    const handleAddEditors = async (usersToAdd) => {
        if (!selectedHuntForEditors || usersToAdd.length === 0) return
        setIsUpdatingEditors(true)
        try {
            const payload = {
                user_ids: usersToAdd.map(String),
                added_by: String(user_id)
            }
            const huntId = selectedHuntForEditors.hunt_id || selectedHuntForEditors.id
            const res = await api.quest.addEditors(huntId, payload)
            if (res && res.status === 200) {
                message.success('Editors added successfully')

                // Map the editors from response to include user details from the 'users' state
                const newEditorsFromApi = res.data?.editors || []
                const updatedEditors = newEditorsFromApi.map(apiEditor => {
                    const userDetail = users.find(u => String(u.user_id) === String(apiEditor.user_id))
                    return {
                        ...apiEditor,
                        user_id: apiEditor.user_id,
                        first_name: userDetail?.user?.first_name || '',
                        last_name: userDetail?.user?.last_name || '',
                        name: userDetail ? `${userDetail.user?.first_name} ${userDetail.user?.last_name}` : '',
                        email: userDetail?.user?.email || ''
                    }
                })

                getQuestContent()
                // Update the selected hunt in the modal if it's open
                setHunts(prev => prev.map(h => {
                    if ((h.hunt_id || h.id) === huntId) {
                        return { ...h, editors: updatedEditors }
                    }
                    return h
                }))
                // Find and update selectedHuntForEditors too
                setSelectedHuntForEditors(prev => ({
                    ...prev,
                    editors: updatedEditors
                }))
            }
        } catch (error) {
            console.error('Error adding editors:', error)
            message.error('Failed to add editors')
        } finally {
            setIsUpdatingEditors(false)
        }
    }

    const handleDeleteEditor = async (editorUserId) => {
        if (!selectedHuntForEditors) return
        setIsUpdatingEditors(true)
        try {
            const huntId = selectedHuntForEditors.hunt_id || selectedHuntForEditors.id
            const res = await api.quest.deleteEditor(huntId, editorUserId, user_id)
            if (res && res.status === 200) {
                message.success('Editor removed successfully')
                getQuestContent()
                setSelectedHuntForEditors(prev => ({
                    ...prev,
                    editors: (prev.editors || []).filter(e => e.user_id !== editorUserId)
                }))
            }
        } catch (error) {
            console.error('Error deleting editor:', error)
            message.error('Failed to remove editor')
        } finally {
            setIsUpdatingEditors(false)
        }
    }



    const columns = [
        {
            title: 'Quest Title',
            dataIndex: 'title',
            key: 'title',
            render: text => <span style={{ fontWeight: 600 }}>{text}</span>
        },
        {
            title: 'Age Group',
            dataIndex: 'age_group',
            key: 'age_group',
            render: age => {
                const option = ageGroupOptions.find(opt => opt.value === age)
                return <Tag color="blue">{option ? option.label : age}</Tag>
            }
        },
        {
            title: 'Total Stops',
            key: 'stops',
            render: (text, record) => (
                <Tag color="purple">{record.stops?.length || 0} Stops</Tag>
            )
        },
        {
            title: 'Actions',
            key: 'action',
            width: 120,
            align: 'right',
            render: (text, record) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                    <Tooltip title="View Quest">
                        <Icon
                            type="eye"
                            style={{
                                color: '#1890ff',
                                fontSize: '18px',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'all 0.3s',
                                background: 'rgba(24, 144, 255, 0.05)'
                            }}
                            className="action-icon-hover"
                            onClick={() => handleView(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Manage Editors">
                        <Icon
                            type="team"
                            style={{
                                color: '#52c41a',
                                fontSize: '18px',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'all 0.3s',
                                background: 'rgba(82, 196, 26, 0.05)'
                            }}
                            className="action-icon-hover"
                            onClick={() => handleOpenEditorModal(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Publish Quest">
                        <Icon
                            type="cloud-upload"
                            style={{
                                color: '#faad14',
                                fontSize: '18px',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'all 0.3s',
                                background: 'rgba(250, 173, 20, 0.05)'
                            }}
                            className="action-icon-hover"
                            onClick={() => {
                                setSelectedHuntForPublish(record)
                                setPublishModalVisible(true)
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete Quest">
                        <Icon
                            type="delete"
                            style={{
                                color: '#ff4d4f',
                                fontSize: '18px',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '4px',
                                transition: 'all 0.3s',
                                background: 'rgba(255, 77, 79, 0.05)'
                            }}
                            className="action-icon-delete"
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Delete Quest',
                                    content: `Are you sure you want to delete "${record.title}"? This action cannot be undone.`,
                                    okText: 'Yes, Delete',
                                    okType: 'danger',
                                    cancelText: 'Cancel',
                                    centered: true,
                                    onOk: () => deleteQuest(record)
                                });
                            }}
                        />
                    </Tooltip>
                </div>
            )
        }
    ]
    const fetchOrgUsers = async () => {
        try {
            let res = await api.organizations.getUsersByOrganizationId(
                active_organization_id
            )
            setUsers(res.data || [])
        } catch (error) {
            console.error('Error fetching organization users:', error)
            setUsers([])
        }
    }
    const deleteQuest = async (hunt) => {
        if (!hunt?.can_edit) {
            message.error('You do not have permission for this action.')
            return
        }
        try {
            const res = await api.quest.deleteQuest(hunt.hunt_id, user_id)
            if (res.data) {
                message.success('Quest deleted successfully')
                getQuestContent()
            }
        } catch (error) {
            console.error('Error deleting quest:', error)
            message.error('Only the creator can delete this hunt.')
        }
    }

    const isEditDisabled = (editFormData.points || 0) === ((editFormData.points_mc || 0) + (editFormData.points_open_ended || 0));

    const debouncedSearch = useCallback(
        _.debounce((value) => {
            setQuery(prev => ({
                ...prev,
                search: value,
                offset: 0
            }))
        }, 300),
        []
    )

    const handleSearch = (e) => {
        const value = e.target.value
        debouncedSearch(value)
    }

    return (
        <Fragment>

            <section className="section" style={{ paddingBottom: '10rem' }}>
                <NewHeader />
                <div style={{ marginTop: '2rem' }}>
                    <div style={{
                        background: '#fff',
                        padding: '24px 32px',
                        borderRadius: '8px',
                        marginBottom: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        borderBottom: '3px solid #1890ff',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '16px'
                    }}>
                        <div style={{ flex: 1, minWidth: '250px' }}>
                            <Title level={2} style={{ margin: 0, color: '#262626' }}>Quest Management</Title>
                            <Text type="secondary" style={{ fontSize: '14px' }}>
                                View, monitor and manage all your generated quests
                            </Text>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <Button
                                type="primary"
                                icon="plus"
                                size="large"
                                className="rounded"
                                onClick={() => history.push('/quest-create')}
                            >
                                Create New Quest
                            </Button>
                            <Input.Search
                                className='list-quest-search'
                                placeholder="Search quests..."
                                onChange={handleSearch}
                                allowClear
                            />
                        </div>
                    </div>

                    <Spin spinning={isFetching}>
                        <div className="form-body">
                            <Table
                                columns={columns}
                                dataSource={hunts}
                                pagination={false}
                            />
                            <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'flex-end' }}>
                                <Pagination
                                    current={(query.offset / query.limit) + 1}
                                    total={total}
                                    pageSize={query.limit}
                                    onChange={handlePageChange}
                                    onShowSizeChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </Spin>
                </div>
            </section>

            <Modal
                title={selectedHunt ? `${selectedHunt.title}` : 'Quest Stops'}
                visible={isModalVisible}
                onCancel={handleCloseMainModal}
                footer={[
                    selectedHunt && (
                        <Button key="close" className="rounded" onClick={handleCloseMainModal}>
                            Close
                        </Button>
                    )
                ].filter(Boolean)}
                width={'75%'}
                centered
            >
                <Spin spinning={isFetching}>
                    {selectedHunt && (
                        <div className="objectives-box">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                <h4 className="corporate-label" style={{ margin: 0 }}>
                                    <Icon type="rocket" /> Quest Objectives
                                </h4>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <p className="objectives-text" style={{ flex: 1, marginRight: '20px' }}>{selectedHunt.objectives}</p>
                            </div>
                        </div>
                    )}

                    {selectedHunt && (
                        <div className="accordion">
                            {(selectedHunt.stops || []).map((content, index) => (
                                <div className="accordion__item" key={index}>
                                    <div
                                        className={`accordion__header ${activeIndex === index ? 'active' : ''}`}
                                        onClick={() => togglePanel(index)}
                                    >
                                        <div className="accordion__title">
                                            <span className="accordion__step-num">#{content.number || index + 1}</span>
                                            {content.title}
                                            {content.objective && (
                                                <Tooltip title={content.objective} placement="top">
                                                    <Icon
                                                        type="info-circle"
                                                        style={{ marginLeft: 8, color: '#1890ff', cursor: 'help' }}
                                                    />
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div className="accordion__meta">
                                            <Tag style={{ backgroundColor: '#f0f5ff', color: '#1d39c4', border: '1px solid #adc6ff' }}>
                                                {content.points || 10} Points
                                            </Tag>
                                            &nbsp;
                                            <Icon type={activeIndex === index ? 'up' : 'down'} />
                                        </div>
                                    </div>

                                    <div className={`accordion__body ${activeIndex === index ? 'open' : ''}`}>
                                        <div className="accordion__content corporate-style">
                                            <div className="accordion__section">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <h4 className="corporate-label">Mission Narrative</h4>
                                                    <Button
                                                        disabled={!selectedHunt?.can_edit}
                                                        type="link"
                                                        size="small"
                                                        icon="edit"
                                                        onClick={() => { handleEditStop(content, index); setEditModalTab('1'); }}
                                                    >
                                                        Edit
                                                    </Button>
                                                </div>
                                                <p className="corporate-text">{content.story}</p>
                                            </div>
                                            <div className="accordion__section">
                                                <h4 className="corporate-label">Mission Objective</h4>
                                                <p className="corporate-text">{content.objective}</p>
                                            </div>

                                            <div className="accordion__grid">
                                                <div className="accordion__section">
                                                    <h4 className="corporate-label">Fun Fact</h4>
                                                    <div className="corporate-insight">
                                                        <Icon type="bulb" style={{ color: '#faad14', marginRight: 8 }} />
                                                        {content.fun_fact}
                                                    </div>
                                                </div>
                                                <div className="accordion__section">
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                        <h4 className="corporate-label" style={{ margin: 0 }}>Open Ended Question</h4>
                                                        {content.points_open_ended !== undefined && (
                                                            <Tag color="cyan">{content.points_open_ended} Points</Tag>
                                                        )}
                                                    </div>
                                                    <p className="corporate-text-secondary">{content.quiz?.open_ended}</p>
                                                </div>
                                            </div>

                                            <div className="accordion__grid">
                                                <div className="accordion__section">
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <h4 className="corporate-label" style={{ margin: 0 }}>Knowledge Check</h4>
                                                            {content.points_mc !== undefined && (
                                                                <Tag color="orange">{content.points_mc} Points</Tag>
                                                            )}
                                                        </div>
                                                        <Button
                                                            disabled={!selectedHunt?.can_edit}
                                                            type="link"
                                                            size="small"
                                                            icon="reload"
                                                            onClick={() => {
                                                                Modal.confirm({
                                                                    title: 'Regenerate Quiz',
                                                                    content: 'Are you sure you want to regenerate the quiz for this stop?',
                                                                    okText: 'Regenerate',
                                                                    cancelText: 'Cancel',
                                                                    centered: true,
                                                                    onOk: () => handleRegenerateQuiz(index)
                                                                })
                                                            }}
                                                            style={{ fontSize: '12px' }}
                                                        >
                                                            Regenerate
                                                        </Button>
                                                    </div>
                                                    <div className="quiz-box">
                                                        <div className="quiz-question">
                                                            <Icon type="question-circle" style={{ color: '#1890ff', marginRight: 8 }} />
                                                            {content.quiz?.multiple_choice?.question}
                                                        </div>
                                                        <ul className="quiz-options">
                                                            {content.quiz?.multiple_choice?.options?.map((opt, i) => (
                                                                <li key={i} className={i === content.quiz?.multiple_choice?.correct_index ? 'correct' : ''}>
                                                                    {i === content.quiz?.multiple_choice?.correct_index && <Icon type="check-circle" />}
                                                                    {opt}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="accordion__section" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                                        <h4 className="corporate-label" style={{ margin: 0 }}>AR Asset</h4>
                                                        <Button
                                                            disabled={!selectedHunt?.can_edit}
                                                            type="link"
                                                            size="small"
                                                            icon="edit"
                                                            onClick={() => {
                                                                handleEditStop(content, index);
                                                                setEditModalTab('2');
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </div>
                                                    {content.ar_asset ? (
                                                        <div style={{ display: 'flex', alignItems: 'top', justifyContent: 'center' }}>
                                                            {renderARMedia(content.ar_asset, { maxHeight: '220px', objectFit: 'contain', borderRadius: '8px', border: "1px solid rgb(217, 217, 217)", padding: "4px" })}
                                                        </div>
                                                    ) : <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bfbfbf' }}>No AR Asset available</div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </Spin>
            </Modal>


            <Modal
                title="Edit Content"
                visible={editModalVisible}
                maskClosable={true}
                onCancel={() => { setEditModalVisible(false); setArAsset(null); }}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => { setEditModalVisible(false); setArAsset(null); }}
                        style={{ borderRadius: 50 }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={isSavingStop}
                        onClick={performUpdate}
                        disabled={!isEditDisabled}
                        style={{ borderRadius: 50 }}
                    >
                        Update
                    </Button>
                ]}
                centered
                width={'60%'}
            >
                <Tabs activeKey={editModalTab} onChange={setEditModalTab}>
                    <TabPane tab="Details" key="1">
                        <Form layout="vertical">
                            <Form.Item label="Stop Title">
                                <Input
                                    value={editFormData.title}
                                    onChange={(e) => setEditFormData({ ...editFormData, title: e.target.value })}
                                    placeholder="Enter the stop title..."
                                />
                            </Form.Item>
                            <Form.Item label="Mission Narrative">
                                <Input.TextArea
                                    rows={6}
                                    value={editFormData.story}
                                    onChange={(e) => setEditFormData({ ...editFormData, story: e.target.value })}
                                    placeholder="Enter the mission narrative/story..."
                                />
                            </Form.Item>
                            <Form.Item label="Mission Objective">
                                <Input.TextArea
                                    rows={4}
                                    value={editFormData.objective}
                                    onChange={(e) => setEditFormData({ ...editFormData, objective: e.target.value })}
                                    placeholder="Enter the mission objective..."
                                />
                            </Form.Item>
                            <Form.Item label="Fun Fact">
                                <Input.TextArea
                                    rows={3}
                                    value={editFormData.fun_fact}
                                    onChange={(e) => setEditFormData({ ...editFormData, fun_fact: e.target.value })}
                                    placeholder="Enter a fun fact..."
                                />
                            </Form.Item>
                            <Form.Item label="Open Ended Question">
                                <Input.TextArea
                                    rows={3}
                                    value={editFormData.open_ended}
                                    onChange={(e) => setEditFormData({ ...editFormData, open_ended: e.target.value })}
                                    placeholder="Enter the open ended question..."
                                />
                            </Form.Item>
                            <Row gutter={16}>
                                {(() => {
                                    const isPointsMatching = isEditDisabled;
                                    const validateStatus = isPointsMatching ? 'success' : 'error';
                                    const helpText = isPointsMatching ? '' : 'Total must equal Quiz Points + OpenEnded Points';

                                    return (
                                        <Fragment>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Total Points"
                                                >
                                                    <InputNumber
                                                        disabled
                                                        min={0}
                                                        style={{ width: '100%' }}
                                                        value={editFormData.points}
                                                        onChange={(val) => setEditFormData({ ...editFormData, points: val })}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Quiz Points"
                                                    validateStatus={validateStatus}
                                                    hasFeedback
                                                >
                                                    <InputNumber
                                                        min={0}
                                                        style={{ width: '100%' }}
                                                        value={editFormData.points_mc}
                                                        onChange={(val) => setEditFormData({ ...editFormData, points_mc: val })}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    label="Open Ended Points"
                                                    validateStatus={validateStatus}
                                                    hasFeedback
                                                >
                                                    <InputNumber
                                                        min={0}
                                                        style={{ width: '100%' }}
                                                        value={editFormData.points_open_ended}
                                                        onChange={(val) => setEditFormData({ ...editFormData, points_open_ended: val })}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            {helpText && <Col span={24}>
                                                <p style={{ color: 'red' }}>{helpText}</p>
                                            </Col>}
                                        </Fragment>
                                    );
                                })()}
                            </Row>
                        </Form>
                    </TabPane>
                    <TabPane tab="AR Assets" key="2">
                        {editFormData.index !== null && selectedHunt && selectedHunt.stops && (
                            <div style={{ textAlign: 'center', padding: '40px 0' }}>
                                {arAsset ? (
                                    <div style={{ marginBottom: 20 }}>
                                        <div style={{ marginBottom: 16 }}>
                                            {renderARMedia(arAsset, { maxWidth: '100%', maxHeight: '300px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #d9d9d9', padding: '4px' })}
                                        </div>
                                        <div style={{ marginTop: 16 }}>
                                            <Button onClick={() => setIsMediaLibraryModalOpen(true)}>
                                                Change AR Asset
                                            </Button>
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ marginBottom: 20 }}>
                                        <p style={{ color: '#8c8c8c', marginBottom: 16 }}>No AR Asset selected for this stop.</p>
                                        <Button type="primary" onClick={() => setIsMediaLibraryModalOpen(true)}>
                                            Select AR Asset
                                        </Button>
                                    </div>
                                )}
                                {/* <ARUploads
                                    tab="3"
                                    selectedData={selectedHunt.stops[editFormData.index]}
                                    editAssets={true}
                                    distroyUnity={false}
                                    hideModal={() => { setEditModalVisible(false); setEditModalTab('1'); }}
                                /> */}
                            </div>
                        )}
                    </TabPane>
                </Tabs>
            </Modal>

            {isMediaLibraryModalOpen && (
                <OrganizationImageSelect
                    allowMultiple={false}
                    allowDelete={false}
                    isPageBuilder={true}
                    visible={isMediaLibraryModalOpen}
                    onClose={() => setIsMediaLibraryModalOpen(false)}
                    onSelectImage={handleSelectedImage}
                    types="AR"
                />
            )}

            <Modal
                title="Edit Quest Details"
                visible={editQuestModalVisible}
                onCancel={() => setEditQuestModalVisible(false)}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => setEditQuestModalVisible(false)}
                        style={{ borderRadius: 50 }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={isSavingQuest}
                        onClick={handleSaveQuest}
                        style={{ borderRadius: 50 }}
                    >
                        Update
                    </Button>
                ]}
                centered
            >
                <Form layout="vertical">
                    <Form.Item label="Quest Title">
                        <Input
                            size="large"
                            value={editQuestFormData.title}
                            onChange={(e) => setEditQuestFormData({ ...editQuestFormData, title: e.target.value })}
                            placeholder="Enter the quest title..."
                        />
                    </Form.Item>
                    <Form.Item label="Quest Objectives">
                        <Input.TextArea
                            rows={4}
                            value={editQuestFormData.objectives}
                            onChange={(e) => setEditQuestFormData({ ...editQuestFormData, objectives: e.target.value })}
                            placeholder="Enter the quest objectives..."
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Manage Quest Editors"
                visible={editorModalVisible}
                onCancel={() => setEditorModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setEditorModalVisible(false)} className="rounded">
                        Close
                    </Button>
                ]}
                centered
            >
                <div>
                    <div style={{ marginBottom: 20 }}>
                        <h4 className="corporate-label">Add New Editors</h4>
                        <Select
                            size='large'
                            mode="multiple"
                            placeholder="Select Users to add as editors"
                            style={{ width: '100%' }}
                            value={[]}
                            onChange={(values) => handleAddEditors(values)}
                            className="scrollable-select"
                            disabled={isUpdatingEditors}
                            showSearch
                            filterOption={(input, option) => {
                                const nameMatch = option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                const emailMatch = (option.props['data-email'] || '').toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                return nameMatch || emailMatch;
                            }}
                        >
                            {users
                                .filter(user => !(selectedHuntForEditors?.editors || []).some(e => e.user_id === user.user_id))
                                .map(user => (
                                    <Option key={user.user_id} value={user.user_id} data-email={user.user?.email}>
                                        {user.user?.first_name + ' ' + user.user?.last_name}
                                    </Option>
                                ))}
                        </Select>
                    </div>

                    <h4 className="corporate-label">Current Editors</h4>
                    <Spin spinning={isUpdatingEditors}>
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {(selectedHuntForEditors?.editors || []).length > 0 ? (
                                (selectedHuntForEditors?.editors || []).map(editor => (
                                    <div key={editor.user_id} style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px',
                                        borderBottom: '1px solid #f0f0f0'
                                    }}>
                                        <div>
                                            <div style={{ fontWeight: 600 }}>{editor.name || `${editor.first_name} ${editor.last_name}`}</div>
                                            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{editor.email}</div>
                                        </div>
                                        <Tooltip title="Remove Editor">
                                            <Icon
                                                type="user-delete"
                                                style={{ color: '#ff4d4f', cursor: 'pointer' }}
                                                onClick={() => handleDeleteEditor(editor.user_id)}
                                            />
                                        </Tooltip>
                                    </div>
                                ))
                            ) : (
                                <div style={{ textAlign: 'center', padding: '20px', color: '#bfbfbf' }}>
                                    No additional editors assigned.
                                </div>
                            )}
                        </div>
                    </Spin>
                </div>
            </Modal>

            <PublishQuestModal
                visible={publishModalVisible}
                onClose={() => setPublishModalVisible(false)}
                hunt={selectedHuntForPublish}
                user={user}
                orgList={orgList}
                onPublishSuccess={getQuestContent}
            />

        </Fragment >
    )
}

const mapStateToProps = state => ({
    user: state.user,
    orgList: state.organizations.list.rows,
})

export default connect(
    mapStateToProps,
)(ListQuest)

